var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlower(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 135,
    viewBox: "0 0 59 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    clipPath: "url(#clip0_5271_1164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.2329 25.4576C51.2329 22.8683 53.5675 19.926 52.8339 17.5874C52.0706 15.167 48.4819 14.2101 47.0643 12.1889C45.6268 10.1522 45.8449 6.33999 43.8722 4.85602C41.9192 3.38741 38.4792 4.76903 36.1347 3.98611C33.8695 3.22877 31.8868 -0.00524902 29.3787 -0.00524902C26.8706 -0.00524902 24.8829 3.22366 22.6226 3.98611C20.2781 4.77415 16.8381 3.39252 14.8852 4.86114C12.9124 6.3451 13.1305 10.1574 11.693 12.194C10.2705 14.2101 6.68179 15.167 5.92341 17.5925C5.18981 19.9311 7.52444 22.8734 7.52444 25.4627C7.52444 28.0519 5.18981 30.9943 5.92341 33.3328C6.68675 35.7532 10.2754 36.7101 11.693 38.7314C13.1305 40.768 12.9124 44.5803 14.8852 46.0642C16.8381 47.5328 20.2781 46.1512 22.6226 46.9341C24.8879 47.6915 26.8706 50.9255 29.3787 50.9255C31.8868 50.9255 33.8744 47.6966 36.1347 46.9341C38.4792 46.1461 41.9192 47.5277 43.8722 46.0591C45.8449 44.5751 45.6268 40.7629 47.0643 38.7263C48.4869 36.7101 52.0756 35.7532 52.8339 33.3277C53.5675 30.9892 51.2329 28.0468 51.2329 25.4576Z",
    fill: "#EA4335",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3689 4.97888V46.1769",
    stroke: "#FCF8ED",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4671 19.6139L10.2705 31.5419",
    stroke: "#FCF8ED",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.368 31.8694L10.3696 19.2864",
    stroke: "#FCF8ED",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1212 8.92932L17.6213 42.2265",
    stroke: "#FCF8ED",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5672 41.8785L17.1702 9.27734",
    stroke: "#FCF8ED",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3689 39.0948C36.6644 39.0948 42.5786 32.9893 42.5786 25.4577C42.5786 17.9261 36.6644 11.8206 29.3689 11.8206C22.0734 11.8206 16.1592 17.9261 16.1592 25.4577C16.1592 32.9893 22.0734 39.0948 29.3689 39.0948Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7329 33.9824C36.2939 32.6349 38.9332 27.7254 37.628 23.0168C36.3227 18.3082 31.5671 15.5835 27.0061 16.931C22.445 18.2785 19.8057 23.1879 21.111 27.8966C22.4162 32.6052 27.1718 35.3299 31.7329 33.9824Z",
    fill: "#DF644D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7532 105.735C57.731 99.5639 60.0062 91.0234 58.5885 83.0458C50.861 81.5823 42.5882 83.9362 36.6104 90.1024C30.6326 96.2685 28.3574 104.814 29.775 112.792C37.5026 114.255 45.7754 111.901 51.7532 105.735Z",
    fill: "#49EA80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2626 90.614L29.7751 112.792",
    stroke: "#1C1D26",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7107 89.038L39.966 102.271L52.9824 104.369",
    stroke: "#1C1D26",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.24186 78.3738C1.26899 72.2026 -1.00615 63.6621 0.40652 55.6845C8.13407 54.221 16.4069 56.5749 22.3847 62.741C28.3625 68.9072 30.6376 77.4528 29.22 85.4304C21.4925 86.8939 13.2197 84.54 7.24186 78.3738Z",
    fill: "#FFCA0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.73755 63.2527L29.22 85.4303",
    stroke: "#1C1D26",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2893 61.6766L19.0291 74.9095L6.0127 77.0024",
    stroke: "#1C1D26",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3315 25.3995V170.142",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5271_1164"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 135,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlower);
export default __webpack_public_path__ + "static/media/flower.1d3b8adb194c205455d076d79dc409ee.svg";
export { ForwardRef as ReactComponent };